export { default } from './parts-item';
